import React, { useContext } from 'react';
import { ThemeContext } from '../../../context/ThemeContext';

/**
 * Minimal, luxury-style menu toggle.
 * Pure CSS transitions (no animation library, no state) so it stays featherlight.
 */
const HamburgerMenu = ({ menuOpen, setMenuOpen, controlsId }) => {
    const { theme, themes } = useContext(ThemeContext);

    const line =
        'absolute right-0 top-1/2 h-px bg-current ' +
        'transition-[transform,width] duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] ' +
        'motion-reduce:transition-none';

    return (
        <div className="md:hidden flex items-center">
            <button
                type="button"
                onClick={() => setMenuOpen((isOpen) => !isOpen)}
                aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
                aria-expanded={menuOpen}
                aria-controls={controlsId}
                className={`
                    group relative flex h-11 w-11 items-center justify-center rounded-full
                    transition-transform duration-300 active:scale-95
                    motion-reduce:transition-none
                    focus:outline-none focus-visible:ring-1 focus-visible:ring-current focus-visible:ring-offset-2 focus-visible:ring-offset-transparent
                    ${themes[theme].text}
                `}
            >
                {/* Hairline ring */}
                <span
                    aria-hidden="true"
                    className={`absolute inset-0 rounded-full border border-current transition-opacity duration-500 ${
                        menuOpen ? 'opacity-50' : 'opacity-25 group-hover:opacity-60'
                    }`}
                />

                {/* Icon */}
                <span aria-hidden="true" className="relative block h-5 w-5">
                    <span
                        className={`${line} w-5`}
                        style={{
                            transform: menuOpen
                                ? 'translateY(-50%) rotate(45deg)'
                                : 'translateY(calc(-50% - 3px))',
                        }}
                    />
                    <span
                        className={`${line} ${
                            menuOpen ? 'w-5' : 'w-3 group-hover:w-5'
                        }`}
                        style={{
                            transform: menuOpen
                                ? 'translateY(-50%) rotate(-45deg)'
                                : 'translateY(calc(-50% + 3px))',
                        }}
                    />
                </span>
            </button>
        </div>
    );
};

export default HamburgerMenu;
